export const createNOf = <U>(n: number, map: (index: number) => U) =>
  Array.from({ length: n }, (_, index) => map(index));
